// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --slider-count: 4;
  --slider-height: 50px;
  --slider-width: 320px;
  --gap: 10px;
  --time: 50s;
}

.slider_container_nbgKw {
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
}
.slider_container_nbgKw::before,
.slider_container_nbgKw::after {
  content: "";
  position: absolute;
  top: 0;
  width: 20px;
  height: 100%;
  z-index: 1;
}

@media (width<=1110px) {
  :root {
    --slider-height: 110px;
    --slider-width: 260px;
  }
  .slider_container_nbgKw {
    row-gap: 0px;
  }
}

@media (width<=860px) {
  :root {
    --slider-width: 200px;
  }
}

@media (width<=460px) {
  :root {
    --slider-height: 90px;
    --slider-width: 180px;
  }
  .slider_container_nbgKw {
    row-gap: 10px;
  }
}

.slide_fO4T6 {
  position: relative;
  width: 1100px;
  height: calc(var(--slider-height) +10px);
  overflow: hidden;
}

.slide_fO4T6 {
  width: var(--slider-width);
  height: var(--slider-height);
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  margin: 0 var(--gap);
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  border-radius: 6.08px;
  background: rgba(0, 0, 0, 0.04);
  padding: 16px;
  align-items: center;
}

.slide_fO4T6 .text_iYhnE {
  -webkit-user-select: none;
          user-select: none;
}

.scrollLeft_P4zZZ {
  animation: scrollLeft_P4zZZ var(--time) linear infinite;
  -webkit-animation: scrollLeft_P4zZZ var(--time) linear infinite;
}
.scrollRight_LLV9d {
  animation: scrollRight_LLV9d var(--time) linear infinite;
  -webkit-animation: scrollRight_LLV9d var(--time) linear infinite;
}

.slider_RnFjC {
  position: relative;
  width: 100%;
  height: var(--slider-height);
  overflow: hidden;
}

.slider_track__JzS1 {
  display: flex;
  transition: transform 1s ease;
}

.slide_fO4T6 {
  flex: 0 0 auto;
  width: var(--slider-width);
  margin: 0 var(--gap);
}
.slider_RnFjC {
  position: relative;
  width: 100%;
  height: var(--slider-height);
  overflow: hidden;
}

.slider_track__JzS1 {
  display: flex;
  transition: transform 1s ease;
}

.slide_fO4T6 {
  flex: 0 0 auto;
  width: var(--slider-width);
  margin: 0 var(--gap);
}

@keyframes scrollLeft_P4zZZ {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(
      calc(-1 * var(--slider-count) * var(--slider-width) + var(--gap) * 2)
    );
  }
}
  
@keyframes scrollRight_LLV9d {
  0% {
    transform: translateX(
      calc(-1 * var(--slider-count) * var(--slider-width) + var(--gap) * 2)
    );
  }

  100% {
    transform: translateX(0);
  }
}

.scrollLeft_P4zZZ {
  animation: scrollLeft_P4zZZ var(--time) linear infinite;
  animation-play-state: running; 
}

.scrollRight_LLV9d {
  animation: scrollRight_LLV9d var(--time) linear infinite;
  animation-play-state: running; 
}

.scrollLeft_P4zZZ:hover {
  animation-play-state: paused;
}

.scrollRight_LLV9d:hover {
  animation-play-state: paused;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/ChatView/ChatTags/ChatTags.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE;IACE,sBAAsB;IACtB,qBAAqB;EACvB;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,qBAAqB;EACrB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,uDAAiD;EACjD,+DAAyD;AAC3D;AACA;EACE,wDAAkD;EAClD,gEAA0D;AAC5D;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE;;KAEC;EACH;AACF;;AAEA;EACE;IACE;;KAEC;EACH;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,uDAAiD;EACjD,6BAA6B;AAC/B;;AAEA;EACE,wDAAkD;EAClD,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":[":root {\n  --slider-count: 4;\n  --slider-height: 50px;\n  --slider-width: 320px;\n  --gap: 10px;\n  --time: 50s;\n}\n\n.slider_container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 40px;\n}\n.slider_container::before,\n.slider_container::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  width: 20px;\n  height: 100%;\n  z-index: 1;\n}\n\n@media (width<=1110px) {\n  :root {\n    --slider-height: 110px;\n    --slider-width: 260px;\n  }\n  .slider_container {\n    row-gap: 0px;\n  }\n}\n\n@media (width<=860px) {\n  :root {\n    --slider-width: 200px;\n  }\n}\n\n@media (width<=460px) {\n  :root {\n    --slider-height: 90px;\n    --slider-width: 180px;\n  }\n  .slider_container {\n    row-gap: 10px;\n  }\n}\n\n.slide {\n  position: relative;\n  width: 1100px;\n  height: calc(var(--slider-height) +10px);\n  overflow: hidden;\n}\n\n.slide {\n  width: var(--slider-width);\n  height: var(--slider-height);\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n  margin: 0 var(--gap);\n  overflow: hidden;\n  box-sizing: border-box;\n  display: flex;\n  border-radius: 6.08px;\n  background: rgba(0, 0, 0, 0.04);\n  padding: 16px;\n  align-items: center;\n}\n\n.slide .text {\n  user-select: none;\n}\n\n.scrollLeft {\n  animation: scrollLeft var(--time) linear infinite;\n  -webkit-animation: scrollLeft var(--time) linear infinite;\n}\n.scrollRight {\n  animation: scrollRight var(--time) linear infinite;\n  -webkit-animation: scrollRight var(--time) linear infinite;\n}\n\n.slider {\n  position: relative;\n  width: 100%;\n  height: var(--slider-height);\n  overflow: hidden;\n}\n\n.slider_track {\n  display: flex;\n  transition: transform 1s ease;\n}\n\n.slide {\n  flex: 0 0 auto;\n  width: var(--slider-width);\n  margin: 0 var(--gap);\n}\n.slider {\n  position: relative;\n  width: 100%;\n  height: var(--slider-height);\n  overflow: hidden;\n}\n\n.slider_track {\n  display: flex;\n  transition: transform 1s ease;\n}\n\n.slide {\n  flex: 0 0 auto;\n  width: var(--slider-width);\n  margin: 0 var(--gap);\n}\n\n@keyframes scrollLeft {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(\n      calc(-1 * var(--slider-count) * var(--slider-width) + var(--gap) * 2)\n    );\n  }\n}\n  \n@keyframes scrollRight {\n  0% {\n    transform: translateX(\n      calc(-1 * var(--slider-count) * var(--slider-width) + var(--gap) * 2)\n    );\n  }\n\n  100% {\n    transform: translateX(0);\n  }\n}\n\n.scrollLeft {\n  animation: scrollLeft var(--time) linear infinite;\n  animation-play-state: running; \n}\n\n.scrollRight {\n  animation: scrollRight var(--time) linear infinite;\n  animation-play-state: running; \n}\n\n.scrollLeft:hover {\n  animation-play-state: paused;\n}\n\n.scrollRight:hover {\n  animation-play-state: paused;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"slider_container": `slider_container_nbgKw`,
	"slide": `slide_fO4T6`,
	"text": `text_iYhnE`,
	"scrollLeft": `scrollLeft_P4zZZ`,
	"scrollRight": `scrollRight_LLV9d`,
	"slider": `slider_RnFjC`,
	"slider_track": `slider_track__JzS1`
};
export default ___CSS_LOADER_EXPORT___;
